import type { AccessLevel } from "@woven/contracts";

const LABEL: Record<AccessLevel, string> = {
  guest: "Guest",
  lite: "Lite",
  pro: "Pro",
  admin: "Admin",
};

/** Compact access-level chip. Gradient for the two paid/elevated tiers, quiet outline otherwise. */
export function AccessBadge({ level }: { level: AccessLevel }) {
  return <span className={`access-badge access-badge--${level}`}>{LABEL[level]}</span>;
}
